
<ng-template #fullFormTemplate let-form_config='formConfig'>
  <div class='full-form' [ngClass]='form_config.formStyle || "style-1"'>
    @if (datasetACS.loading.value) {
      <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
    }
    <form-viewer #formViewer
      [record]='datasetRS.record.value'
      [dataContainerService]='datasetACS'
      [formConfig]='form_config'
    ></form-viewer>

    @if (datasetACS.canEdit(datasetRS.record.value)) {
      <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
        <!--<button mat-raised-button>Annulla</button>-->
        <button color='accent' [disabled]='datasetACS.loading.value' mat-flat-button (click)='onSave()'>
          @if (!datasetACS.loading.value) {
            <span>Salva</span>
          }
          @if (datasetACS.loading.value) {
            <span>Azione in corso ...</span>
          }
        </button>
      </div>
    }
  </div>
</ng-template>

@if (inputFormConfig) {
  <ng-container [ngTemplateOutlet]="fullFormTemplate" [ngTemplateOutletContext]='{formConfig:inputFormConfig}'></ng-container>
}
@if (!inputFormConfig && datasetACS.datasetConfig && datasetACS.datasetConfig.stepViewConfig) {
  @if (datasetACS.datasetConfig && datasetACS.datasetConfig.stepViewConfig) {
    @switch (datasetACS.datasetCode) {
      @case ("trip_packages") {
        @switch (datasetACS.getValueFromKeyPath("domainContext.domainTpl")) {
          @case (1) {
            <simp-temp-view-container
              [stepViewConfig]='stepViewConfig'
            ></simp-temp-view-container>
          }
          @default {
            <common-step-view-container
              [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
            ></common-step-view-container>
          }
        }
      }
      @case ("products") {
        <simp-temp-view-container
          [stepViewConfig]='productStepViewConfig'
        ></simp-temp-view-container>
      }
      @default {
        <common-step-view-container
          [stepViewConfig]='datasetACS.datasetConfig.stepViewConfig'
        ></common-step-view-container>
      }
    }
  }
}

@if (!inputFormConfig && datasetACS.datasetConfig && !datasetACS.datasetConfig.stepViewConfig) {
  @switch (datasetACS.datasetConfig.name) {
    @default {
      @if (!datasetACS.actionConfig || !datasetACS.actionConfig.viewConfig || !datasetACS.actionConfig.viewConfig.formConfig) {
        <h2>In Construction</h2>
      }
      @if (datasetACS.actionConfig && datasetACS.actionConfig.viewConfig && datasetACS.actionConfig.viewConfig.formConfig) {
        <ng-container [ngTemplateOutlet]="fullFormTemplate" [ngTemplateOutletContext]='{formConfig: datasetACS.actionConfig.viewConfig.formConfig}'></ng-container>
      }
    }
  }
}
